module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_j_normal.2ed6c6fa.png";